import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api.get('/auth/me')
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setIsLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    setUser(res.data.user);
    // fetch full user (with store) after login
    const me = await api.get('/auth/me');
    setUser(me.data);
    return me.data;
  };

  const loginDemo = async (role) => {
    const res = await api.post('/auth/demo-login', { role });
    setUser(res.data.user);
    const me = await api.get('/auth/me');
    setUser(me.data);
    return me.data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    setUser(null);
  };

  const refreshUser = async () => {
    const res = await api.get('/auth/me');
    setUser(res.data);
    return res.data;
  };

  // Convenience: current store object (includes business_type)
  const store = user?.store || null;
  const businessType = store?.business_type || 'laundry';

  return (
    <AuthContext.Provider value={{ user, store, businessType, isLoading, login, loginDemo, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
